import { deleteRequest } from "../httpMethods";

export const deleteWishlist = (payload) =>
    deleteRequest(`v1/wishlist`, payload);

export const deleteCart = (payload) =>
    deleteRequest(`v1/cart`, payload);

export const deleteAddress = (id) =>
    deleteRequest(`v1/address/${id}`);